/**
 * Vilkårsboks for Servida.
 *
 * Denne håndterer kun visningen av feilmeldinger.
 * Selve utsjekk-valideringen håndteres av Zapiet.
 */

if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;

      this.terms_checkbox =
        this.querySelector('input[type="checkbox"][id^="CartTerms"]') ||
        this.querySelector('input[type="checkbox"]');

      if (!this.terms_checkbox) {
        return;
      }

      // Fjern eventuelle tidligere egendefinerte valideringsfeil.
      this.terms_checkbox.setCustomValidity('');

      this.error_message = document.createElement('p');

      this.error_message.className = 'servida-terms-error';

      this.error_message.style.cssText =
        'color: #d93025; font-size: 0.875rem; margin-top: 0.5rem; display: none;';

      this.error_message.setAttribute('role', 'alert');

      this.error_message.textContent =
        window.theme?.strings?.requiresTerms ||
        'Du må godta våre vilkår før du kan gå videre.';

      this.appendChild(this.error_message);

      this.terms_checkbox.addEventListener('change', () => {
        if (this.terms_checkbox.checked) {
          this.hideError();
        }
      });
    }

    showError() {
      if (!this.error_message || !this.terms_checkbox) {
        return;
      }

      this.error_message.style.display = 'block';

      this.terms_checkbox.setAttribute('aria-invalid', 'true');

      this.terms_checkbox.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      this.terms_checkbox.focus({
        preventScroll: true
      });
    }

    hideError() {
      this.error_message.style.display = 'none';

      this.terms_checkbox.removeAttribute('aria-invalid');

      this.terms_checkbox.setCustomValidity('');
    }
  }

  customElements.define('terms-checkbox', TermsCheckbox);
}